import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AvisInitialType } from '../models/AvisInitialType';
import { CTRL_438 } from '../../../validators/438/ctrl438';
import { CTRL_439 } from '../../../validators/439/ctrl439';
import { Step1 } from '../../../../shared/models/component-messages/diveAT/step1';
@Component({
  selector: 'app-avis-initial-type',
  templateUrl: './avis-initial-type.component.html'
})
export class AvisInitialTypeComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'AvisInitialType';
  @Input() parentForm: FormGroup;
  @Input() avisInitial: AvisInitialType;
  @Input() disabled: boolean;

  public step1 = new Step1();

  public rg1 = 'CTRL_IDWEB';
  public rg2 = '_STEP_ID_1_' + CTRL_438.id + '_1';

  constructor() {
  }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_idWebNames_json() }));
    this.parentForm.addControl(this.rg2, new FormControl({ rgCtrls: this.getCtrl_438Names_json() }));
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
	  return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}

  public getCtrl_438Names_json(): any {
    return { datePublication: "_SepSep_Attribution_SepSep_AvisInitial_SepSep_AvisInitialType_SepAtt_datePublication" };
  }

  getCtrl_idWebNames_json(): any {
    return { idWeb: "_SepSep_Attribution_SepSep_AvisInitial_SepSep_AvisInitialType_SepAtt_idWeb" };
  }
}
